import { useQuery } from '@tanstack/react-query';
import type { Series } from '@jwp/ott-common/types/series';
import ContentApiService from '@jwp/ott-common/src/services/ContentApiService';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useTranslation } from 'react-i18next';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useFirstEpisode = ({ series }: { series: Series | undefined }) => {
  const contentApiService = getModule(ContentApiService);
  const { i18n } = useTranslation();
  const config = useConfigStore.getState().config;

  const { isLoading, data } = useQuery({
    queryKey: ['first-episode', series?.series_id],
    queryFn: async () => {
      const item = await contentApiService.getEpisodes({
        seriesId: series?.series_id,
        pageLimit: 1,
        language: i18n.language,
        config,
      });

      return item?.episodes?.[0];
    },
    enabled: !!series?.series_id,
  });

  return {
    isLoading,
    data,
  };
};
